import {
  Component,
  CUSTOM_ELEMENTS_SCHEMA,
  Input,
  Output,
  EventEmitter,
  ChangeDetectionStrategy,
} from '@angular/core';

import { CONFIRMATION_MESSAGE } from '../create-request-wizard.types';

@Component({
  selector: 'app-step-confirmation',
  standalone: true,
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [],
  templateUrl: './step-confirmation.component.html',
  styleUrls: ['./step-confirmation.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StepConfirmationComponent {
  @Input() requestNumber!: string;

  @Output() viewRequest = new EventEmitter<void>();

  readonly confirmationMessageTemplate = CONFIRMATION_MESSAGE;

  get confirmationMessage(): string {
    return this.confirmationMessageTemplate.replace(
      '{REQUEST_NUMBER}',
      this.requestNumber ?? ''
    );
  }

  navigateToRequest(): void {
    this.viewRequest.emit();
  }

  canProceed(): boolean {
    return true;
  }
}
